// One entry per project. Routes are generated from this list, so a project cannot exist without a page.
// Only confirmed facts belong here. `links.code` and `links.live` stay null until real URLs exist;
// null hides the link. `body` stays empty until the owner supplies real write-ups.
import dimensions from './images.generated.json';

const shot = (slug, name, caption, alt) => ({
  src: `/images/projects/${slug}/${name}`,
  width: dimensions[`${slug}/${name}`].width,
  height: dimensions[`${slug}/${name}`].height,
  caption,
  alt,
});

export const projects = [
  {
    slug: 'ecommerce',
    path: '/ecommerce',
    title: 'E-Commerce Platform',
    summary: 'WorldBites, an online shop with a product catalog, cart, seller dashboard and chat support.',
    stack: ['React', 'Node.js', 'MongoDB'],
    body: [],
    links: { code: null, live: null },
    images: [
      shot('ecommerce', 'home', 'Homepage', 'WorldBites homepage'),
      shot('ecommerce', 'catalog', 'Product catalog', 'WorldBites product catalog'),
      shot('ecommerce', 'details', 'Product details', 'WorldBites product details page'),
      shot(
        'ecommerce',
        'cart',
        'Cart',
        'WorldBites cart listing one product with quantity controls, a total and a checkout button'
      ),
      shot('ecommerce', 'seller', 'Seller dashboard', 'WorldBites seller dashboard'),
      shot('ecommerce', 'chat', 'Chat support', 'WorldBites chat support screen'),
    ],
  },
  {
    slug: 'pdfgenius',
    path: '/pdfgenius',
    title: 'PDF Genius',
    summary: 'Upload a PDF, get a summary, ask questions about it, and search inside it.',
    stack: ['React', 'Python', 'Gemini AI'],
    body: [],
    links: { code: null, live: null },
    images: [
      shot('pdfgenius', 'dashboard', 'Dashboard', 'PDF Genius dashboard'),
      shot('pdfgenius', 'summary', 'Smart summarization', 'PDF Genius summary of an uploaded document'),
      shot('pdfgenius', 'qa', 'Interactive Q&A', 'PDF Genius question and answer screen'),
      shot('pdfgenius', 'search', 'Search options', 'PDF Genius search options'),
    ],
  },
  {
    slug: 'bookings',
    path: '/bookings',
    title: 'PhotoStudio Bookings',
    summary:
      'A booking platform for a photo studio: pick a package and a time slot, pay online, and manage sessions as admin.',
    stack: ['React', 'Node.js', 'MongoDB', 'Server-Sent Events', 'Midtrans'],
    body: [],
    links: { code: null, live: null },
    images: [
      shot(
        'bookings',
        'packages',
        'Packages',
        'PhotoStudio package list with prices, durations and a Book This Package button on each'
      ),
      shot('bookings', 'slots', 'Real-time slot booking', 'PhotoStudio time slot picker'),
      shot('bookings', 'profile', 'User profile', 'PhotoStudio user profile'),
      shot('bookings', 'payment', 'Midtrans payment', 'PhotoStudio payment screen using Midtrans'),
      shot('bookings', 'admin', 'Admin dashboard', 'PhotoStudio admin dashboard'),
      shot('bookings', 'reports', 'Reports and analytics', 'PhotoStudio reports and analytics'),
    ],
  },
];

export const findNext = (slug) => {
  const i = projects.findIndex((p) => p.slug === slug);
  return projects[(i + 1) % projects.length];
};
